import axios from "axios";
import { firestore } from "../firebase.config";

// Helper function to detect browser name
const getBrowserName = () => {
    const userAgent = navigator.userAgent;
    if (userAgent.includes('Chrome') && !userAgent.includes('Edg')) return 'Chrome';
    if (userAgent.includes('Firefox')) return 'Firefox';
    if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) return 'Safari';
    if (userAgent.includes('Edg')) return 'Edge';
    if (userAgent.includes('MSIE') || userAgent.includes('Trident/')) return 'Internet Explorer';
    return 'Unknown';
};

// Helper function to detect browser version
const getBrowserVersion = () => {
    const userAgent = navigator.userAgent;
    const browserName = getBrowserName();
    
    if (browserName === 'Chrome') {
        const match = userAgent.match(/Chrome\/(\d+)/);
        return match ? match[1] : 'Unknown';
    } else if (browserName === 'Firefox') {
        const match = userAgent.match(/Firefox\/(\d+)/);
        return match ? match[1] : 'Unknown';
    } else if (browserName === 'Safari') {
        const match = userAgent.match(/Version\/(\d+)/);
        return match ? match[1] : 'Unknown';
    } else if (browserName === 'Edge') {
        const match = userAgent.match(/Edg\/(\d+)/);
        return match ? match[1] : 'Unknown';
    }
    return 'Unknown';
};

// Helper function to detect operating system
const getOperatingSystem = () => {
    const userAgent = navigator.userAgent;
    if (userAgent.includes('Windows')) return 'Windows';
    if (userAgent.includes('Mac')) return 'macOS';
    if (userAgent.includes('Linux')) return 'Linux';
    if (userAgent.includes('Android')) return 'Android';
    if (userAgent.includes('iOS')) return 'iOS';
    return 'Unknown';
};

// Helper function to get connection information
const getConnectionInfo = () => {
    if ('connection' in navigator) {
        const connection = navigator.connection;
        return {
            effectiveType: connection.effectiveType,
            downlink: connection.downlink,
            rtt: connection.rtt,
            saveData: connection.saveData
        };
    }
    return 'Not available';
};

const getBrowserDetails = () => {
    try {
        const details = {
            // Browser Information
            userAgent: navigator.userAgent,
            browserName: getBrowserName(),
            browserVersion: getBrowserVersion(),
            
            // System Information
            platform: navigator.platform,
            operatingSystem: getOperatingSystem(),
            language: navigator.language,
            languages: navigator.languages,
            
            // Time and Location
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            timezoneOffset: new Date().getTimezoneOffset(),
            
            // Timestamp
            timestamp: new Date().toISOString()
        };
        
        return details;
    } catch (error) {
        // console.error('Error getting browser details:', error);
        return null;
    }
};

const getIpAddress = async () => {
    try {
        const response = await axios.get('https://api.ipify.org/?format=json');
        return response.data.ip;
    } catch (error) {
        // console.error('Error fetching IP address:', error);
        return 'Unable to fetch';
    }
};

export const collectAllUserDetails = async (data, email, name, addToBlockedUsers) => {
    try {
        
        const browserDetails = getBrowserDetails();
        const ipAddress = await getIpAddress();
        
        if (!browserDetails || !ipAddress) {
            // console.error('Failed to collect browser details or IP address');
            return;
        }
        
        const fullDetails = {
            ...browserDetails,
            ipAddress: ipAddress,
            timestamp: new Date().toISOString()
        };

        // Check if IP is already blocked
        try {

            const ipDoc = await firestore.collection("blockedIps").doc(ipAddress).get();
            if (!ipDoc.exists) {
                // Add IP to blocked IPs collection
                await firestore.collection("blockedIps").doc(ipAddress).set({...fullDetails, email});
            }
        } catch (firebaseError) {
            // console.error('Error checking/adding blocked IP:', firebaseError);
        }

        if(addToBlockedUsers){
            try{
                await firestore.collection("blockedUsers").doc(email).set({ email, timestamp: new Date().getTime(), name});
            }catch(error){
                // console.error('Error adding to blocked users:', error);
            }
        }

        // Add user details to blockedUsers collection if email exists
        // if (data && email) {
        //     try {
        //         // Check if this IP is already associated with this user
        //         if (!data[ipAddress]) {
        //             const updateData = {};
        //             const ipAddressKey = ipAddress.replaceAll(".", "_");
        //             updateData[ipAddressKey] = fullDetails;
                    
        //             await firestore.collection("blockedUsers").doc(email).update(updateData);
        //         }
        //     } catch (firebaseError) {
        //         console.error('Error updating user details:', firebaseError);
        //     }
        // }
        
        return fullDetails;
    } catch (error) {
        console.error('Error collecting user details:', error);
        return null;
    }
};

